export const banen = {
  title: "Mijn banen",
  description: "De banen waarop je een rol hebt.",
  needsProvider:
    "Je bent in VBS wedstrijdleider van heel Jeugdbrandweer Nederland. Log uit en log in met Google of Microsoft om alle banen te beheren.",
  filters: {
    date: "Datum",
    klasse: "Klasse",
    level: "Niveau",
    region: "Provincie",
    jbnl: "JBNL of niet",
  },
  zoek: "Zoek op locatie, baannummer of klasse",
  zoekLabel: "Banen zoeken",
  telling_one: "1 baan",
  telling_other: "{{count}} banen",
  tellingGefilterd_one: "1 van {{totaal}} banen",
  tellingGefilterd_other: "{{count}} van {{totaal}} banen",
  columns: {
    date: "Datum",
    klasse: "Klasse",
    level: "Niveau",
    location: "Locatie",
    number: "Baan",
    ploegen: "Ploegen",
  },
  empty: "Geen baan past bij dit filter.",
  none: "Je hebt nog geen rol op een baan.",
  detail: {
    back: "Mijn banen",
    roles: "Jouw rollen",
    role: {
      beheerder: "Beheerder",
      waarnemer: "Waarnemer",
    },
    facts: "{{klasse}}, niveau {{level}}",
    location: "Locatie: {{location}}",
    number: "Baan {{number}}",
    region: "Provincie: {{region}}",
    jurylijsten: "Jouw functies",
    unassigned_one: "1 functie heeft nog geen waarnemer.",
    unassigned_other: "{{count}} functies hebben nog geen waarnemer.",
    assign: "Waarnemer indelen",
    vragen_one: "1 vraag",
    vragen_other: "{{count}} vragen",
    alles: "Alles invullen",
    functies_one: "1 functie",
    functies_other: "{{count}} functies",
    noJurylijsten: "Er zijn geen jurylijsten aan je toegewezen op deze baan.",
    onDevice: "Deze baan staat op dit apparaat. Je kunt ook zonder verbinding verder.",
  },
  namens: {
    title: "Invullen namens een waarnemer",
    description: "Vul een jurylijst in voor een waarnemer die dat zelf niet kan. Staat de waarnemer er niet bij? Deel de waarnemer eerst in via beheer.",
    algemeen: "Algemeen",
    none: "Nog geen waarnemer ingedeeld.",
    open: "Invullen namens",
    action: "Invullen namens {{name}}",
  },
} as const;
